import React from "react"
import { Link } from "gatsby"

import Layout from "../components/Layout"
import PageHeader from "../components/PageHeader"
import SectionTitle from "../components/SectionTitle"
import Services from "../components/Services"
// import TimelineTabs from "../components/TimelineTabs"
import Testimonials from "../components/Testimonials"

const Clients = () => (
  <Layout title="Clients">
    <PageHeader
      className="clients-header"
      title="WE'RE HERE TO HELP"
      subtitle="Our Clients"
    />

    {/* ================= Start Mission Section ================= */}
    <section className="section-sm shaded">
      <div className="container">
        <SectionTitle title="Our Mission">
          <p>
            We aim to provide high quality, pro-bono consulting services to help
            your business become more successful. All we ask for is a little bit
            of your time! Each engagement is composed of a highly motivated team
            of undergraduate business analysts who are mentored by MBA
            candidates and consultants from top firms. Through this team, we
            come up with sustainable solutions to help your business thrive.
          </p>
        </SectionTitle>
      </div>
    </section>
    {/* ================= End Mission Section ================= */}

    {/* ================= Start Services Section ================= */}
    <section className="section-sm services">
      <div className="container">
        <SectionTitle title="Our Services" hasPadding={true}>
          <p>
            Our team provides a variety of services to our clients based on
            needs and expectations. Our engagements often comprise multiple
            aspects of the services described below.
          </p>
        </SectionTitle>
        <Services />
      </div>
    </section>
    {/* ================= End Services Section ================= */}

    {/* ================= Start Timeline Section ================= */}
    {/* <section className="section-sm shaded">
      <div className="container">
        <SectionTitle title="Project Timeline" hasPadding={false} />
        <TimelineTabs />
      </div>
    </section> */}
    {/* ================= End Timeline Section ================= */}

    {/* ================= Start Testimonial Section ================= */}
    <section className="section testimonial">
      <div className="container">
        <Testimonials />
      </div>
    </section>
    {/* ================= End Testimonial Section ================= */}

    {/* ================= Start Scoping Section ================= */}
    <section className="section-sm shaded">
      <div className="container">
        <div className="title text-center">
          <h2>Schedule a Scoping Session Now!</h2>
          <br />
          <Link to="/contact">
            <button type="button" id="page-route" className="btn btn-light">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
    {/* ================= End Scoping Section ================= */}
  </Layout>
)

export default Clients
